"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pagination;
var _react = _interopRequireDefault(require("react"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _PrevNextPageButton = _interopRequireDefault(require("./PrevNextPageButton"));
var _PageButtons = _interopRequireDefault(require("./PageButtons"));
var _Pagination_css = _interopRequireDefault(require("./Pagination_css"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FirstLastPageButton = _interopRequireDefault(require("./FirstLastPageButton"));
var _getLanguage = _interopRequireDefault(require("../utils/getLanguage"));
Pagination.propTypes = {
  /** Callback run when a page is changed, expects new page number. */
  changePage: _propTypes.default.func.isRequired,
  /** Currently visible page (1-based). */
  currentPage: _propTypes.default.number.isRequired,
  /** Number of pages available. */
  totalPages: _propTypes.default.number.isRequired,
  /** Theme color variant [primary, accent, error, success] */
  themeColor: _propTypes.default.oneOf(["primary", "accent", "error", "success"])
};
function Pagination(_ref) {
  let {
    changePage,
    currentPage,
    totalPages,
    themeColor = "primary"
  } = _ref;
  (0, _appendCss.default)("arc_pagination", _Pagination_css.default);
  const language = (0, _getLanguage.default)();
  function goToNextPage() {
    let nextPage = currentPage + 1;
    goToPage(nextPage);
  }
  function goToPrevPage() {
    let prevPage = currentPage - 1;
    goToPage(prevPage);
  }
  function goToLastPage() {
    goToPage(totalPages);
  }
  function goToFirstPage() {
    goToPage(1);
  }
  function goToPage(pageNumber) {
    changePage(pageNumber);
  }
  return totalPages <= 1 ? null :
  /*#__PURE__*/
  // circuit breaker, don't render pagination if only 1 page exists
  _react.default.createElement("nav", {
    role: "navigation",
    "aria-label": "pagination",
    className: `Pagination ${themeColor}-color`
  }, /*#__PURE__*/_react.default.createElement(_FirstLastPageButton.default, {
    isFirstPageButton: true,
    currentPage: currentPage,
    finalPage: totalPages,
    clickHandler: goToFirstPage,
    language: language
  }), /*#__PURE__*/_react.default.createElement(_PrevNextPageButton.default, {
    clickHandler: goToPrevPage,
    currentPage: currentPage,
    finalPage: totalPages,
    isPrevButton: true,
    language: language
  }), /*#__PURE__*/_react.default.createElement(_PageButtons.default, {
    currentPage: currentPage,
    totalPages: totalPages,
    clickHandler: goToPage,
    language: language
  }), /*#__PURE__*/_react.default.createElement(_PrevNextPageButton.default, {
    clickHandler: goToNextPage,
    currentPage: currentPage,
    finalPage: totalPages,
    isPrevButton: false,
    language: language
  }), /*#__PURE__*/_react.default.createElement(_FirstLastPageButton.default, {
    isFirstPageButton: false,
    currentPage: currentPage,
    finalPage: totalPages,
    clickHandler: goToLastPage,
    language: language
  }));
}